<template>
  <div class="navbar-header-model">
    <ClientOnly>
      <div class="d-flex tabs-bella">
        <NuxtLink
          v-for="(tab, i) in tabsHeader"
          :key="`t${i}`"
          :class="`${ tab.val == selectedTab ? 'active' : '' } col-3`"
          :to="{
            name: `language-${tab.path}`,
            params: {
              language: route.params.language,
            },
          }"
        >
          <div class="tab-bella">{{ tab.name }}</div>
        </NuxtLink>
      </div>
    </ClientOnly>
  </div>
</template>

<script lang="ts" setup>
import translateModel from "@/tradutors/model";

const route = useRoute();

const selectedTab = computed(() => validOptionNavbarUrlPainel());
const tabsHeader = computed(() =>
  route.params.language === "pt-br"
    ? translateModel.portugues.navBarPages
    : translateModel.ingles.navBarPages
);

function validOptionNavbarUrlPainel() {
  const str = route.name;
  switch (true) {
    case str.includes("language-modelos"):
      return 0;
    case str.includes("language-videos"):
      return 1;
    case str.includes("language-making-of"):
      return 2;
    case str.includes("language-lives"):
      return 3;
    default:
      return 0;
  }  
}

</script>

<style scoped lang="css">
.tabs-bella {
  cursor: pointer;
  background-color: #f8f8f8;
}

.navbar-header-model >>> .tab-bella {
  height: 50px;
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 44px;
  top: 5px;
  text-align: center;
}

.navbar-header-model .tabs-bella > .active {
  border: 0px;
}

.navbar-header-model .tabs-bella > .active::after {
  content: "";
  background: #b20000;
  position: absolute;
  left: 25%;
  width: 50%;
  height: 3px;
  bottom: 12px;
}

.tabs-bella >>> .tab-bella {
  padding: 0px 35px;
}

.tabs-bella >>> .active .tab-bella {
  color: #b20000;
  border-color: #b20000;
  font-weight: bold;
  font-family: "Roboto-Bold";
}

.more-profile {
  font-weight: 500;
  background-color: black !important;
  border: 1px solid black !important;
  border-radius: 30px !important;
  color: white;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}

.more-profile svg {
  color: #b20;
  margin-left: 8px;
}

:deep(.vl-icon) {
  transform: translate(0%, -500%);
}
/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .tabs-bella >>> .tab-bella {
    padding: 0px 5px;
  }

  .navbar-header-model >>> .tab-bella {
    font-size: 15px !important;
  }

  .tabs-bella {
    margin-left: 0px;
  }

  :deep(.icon-arrow-ios-left::before) {
    background-color: #000000;
  }
}
</style>
